import React, { useEffect, useState } from "react";
import Panel, { btnGhost, btnPrimary, btnDanger, inputCls, labelCls } from "./Panel";

/**
 * Confirmation for row actions. `withReason` adds an optional free-text reason
 * (used by Delist). onConfirm(reason) may return a promise; the dialog stays
 * open and shows `error` until the parent closes it.
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  danger = false,
  withReason = false,
  reasonLabel = "Reason (optional)",
  busy = false,
  error = "",
  onConfirm,
  onClose,
}) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Panel
      open={open}
      onClose={onClose}
      busy={busy}
      variant="center"
      labelId="tl-confirm-title"
      title={title}
      footer={
        <>
          {error && <div className="mr-auto text-sm text-red-300" role="alert">{error}</div>}
          <button type="button" className={btnGhost} onClick={onClose} disabled={busy}>Cancel</button>
          <button type="button" className={danger ? btnDanger : btnPrimary} onClick={() => onConfirm(reason.trim())} disabled={busy}>
            {busy ? "Working..." : confirmLabel}
          </button>
        </>
      }
    >
      <div className="text-sm text-gray-200">{message}</div>
      {withReason && (
        <div>
          <label className={labelCls} htmlFor="tl-confirm-reason">{reasonLabel}</label>
          <textarea
            id="tl-confirm-reason"
            rows={3}
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className={`${inputCls} resize-y`}
          />
        </div>
      )}
    </Panel>
  );
}
